import api from "./api";

// Revoga o access token (Passport) no servidor antes de limpar o storage local.
// Sem isso, um token que tenha vazado continua valido ate o exp (~1 ano).
// Deve ser chamado ANTES de limpar o localStorage, pois o interceptor do api
// le o `userToken` de la para montar o header Authorization.
// Nunca lanca: se a rede falhar, o logout do front segue normalmente.
export async function revokeTalentToken() {
  try {
    await api.get("/api/v1/talent/logout");
  } catch (_) {
    // best-effort: se a revogacao falhar, o logout do front segue mesmo assim.
  }
}

export default revokeTalentToken;
